import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Empty } from 'antd'

import ApplyFieldRuleItem from './ApplyFieldRuleItem'
import { getUid } from '../../../../plugins/utils'
import { RelationTypeMap } from '../../../../common/common'

const ApplyFieldRuleTree = forwardRef((props, ref) => {
  const [ruleTree, setRuleTree] = useState({ code: 'root', children: [] })

  useImperativeHandle(ref, () => {
    return {
      addRuleByField,
      resetRules,
      getRuleTree,
      setRuleTreeData
    }
  })

  const getAvailableFieldsForSubRule = (rootFieldCode) => {
    return (props.selectedFieldList || []).filter(field => {
      return field.fieldCode !== rootFieldCode
    })
  }

  const addRuleByField = (field) => {
    if (!field?.fieldCode) {
      return false
    }
    const exists = ruleTree.children.some(item => {
      return item.formData?.fieldCode === field.fieldCode
    })
    if (exists) {
      return false
    }

    const newRule = {
      parent: {
        code: 'root',
        label: field.fieldName
      },
      code: getUid(),
      formData: {
        fieldCode: field.fieldCode,
        fieldName: field.fieldName,
        fieldType: field.fieldType,
        fieldJoinSelect: field.fieldJoinSelect,
        ruleLogicType: RelationTypeMap.or
      },
      children: []
    }

    setRuleTree({
      code: 'root',
      children: [newRule, ...ruleTree.children]
    })
    return true
  }

  const resetRules = () => {
    setRuleTree({ code: 'root', children: [] })
  }

  const setRuleTreeData = (rules) => {
    setRuleTree({
      code: 'root',
      children: rules || []
    })
  }

  const getRuleTree = () => {
    return ruleTree
  }

  const cloneTree = (nodes) => {
    return JSON.parse(JSON.stringify(nodes || []))
  }

  const removeRuleFromTree = (nodes, targetCode) => {
    return nodes
      .filter(node => node.code !== targetCode)
      .map(node => ({
        ...node,
        children: node.children?.length ? removeRuleFromTree(node.children, targetCode) : []
      }))
  }

  const deleteRuleItem = (rule) => {
    setRuleTree({
      code: 'root',
      children: removeRuleFromTree(ruleTree.children, rule.code)
    })
  }

  const ruleUpdate = () => {
    setRuleTree({
      code: 'root',
      children: cloneTree(ruleTree.children)
    })
  }

  const renderRules = () => {
    if (!ruleTree.children?.length) {
      return <Empty description="暂无规则，请添加字段" />
    }

    return ruleTree.children.map(ruleItem => {
      return (
        <ApplyFieldRuleItem
          key={ ruleItem.code }
          ruleItem={ ruleItem }
          rootFieldCode={ ruleItem.formData?.fieldCode }
          availableFields={ getAvailableFieldsForSubRule(ruleItem.formData?.fieldCode) }
          ruleUpdate={ ruleUpdate }
          deleteRuleItem={ deleteRuleItem }
          disabled={ props.disabled }
        ></ApplyFieldRuleItem>
      )
    })
  }

  return (
    <div ref={ ref }>
      { renderRules() }
    </div>
  )
})

export default ApplyFieldRuleTree
